import Profile from './Profile'

export { default as Edit } from './Edit'
export { default as BankDetails } from './Monetary/BankDetails'
export { default as MoneyPot } from './Monetary/MoneyPot'
export { default as CreditMoney } from './Monetary/CreditMoney'
export { default as WireMoney } from './Monetary/WireMoney'
export default Profile
